import { useFormContext } from 'react-hook-form';
import { LocationSelect } from 'src/components/Common/LocationSelect';
import { FormInput } from 'src/components/forms/components/FormInput';
import { FormRow } from 'src/components/forms/layout/FormRow';
import { DriverFormContext } from '../../driverSchema';

export const CustomerAddress = () => {
  const { watch, getValues } = useFormContext<DriverFormContext>();
  const jurisdiction = watch('jurisdiction');
  const country = watch('country');
  return (
    <>
      <FormRow>
        <FormInput
          name="addressLine1"
          label="Address Line 1"
          placeholder="Enter Address Line 1"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormInput
          name="addressLine2"
          label="Address Line 2"
          placeholder="Enter Address Line 2"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
      </FormRow>
      <FormRow>
        <FormInput
          name="city"
          label="City"
          placeholder="Enter City"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
        <FormInput
          name="postalCode"
          label="Postal Code"
          placeholder="Enter Postal Code"
          bg="white"
          hideOptionalLabel
          controlStyleProps={{ maxWidth: { base: '100%', sm: '320px' } }}
        />
      </FormRow>
      <FormRow>
        <LocationSelect
          defaultLocation={{
            country: country ?? '',
            jurisdiction: jurisdiction ?? '',
          }}
          isCountryVisible={true}
          isJurisdictionVisible={true}
          isRequired={true}
        />
      </FormRow>
    </>
  );
};
